/**
 * Betrag aus deutscher oder englischer Schreibweise in Cent.
 * „120.000,50“, „120000,5“, „120000.50“, „1.234“ (= 1234 €), „-500“ → Cent; ungültig → null.
 */
export function parseEuroToCents(input, lang = 'de') {
    let s = input.trim().replace(/\s|€|EUR/gi, '');
    if (!s)
        return null;
    if (lang === 'en') {
        // Englisch: Komma = Tausender, Punkt = Dezimal
        const neg = s.startsWith('-');
        const body = neg ? s.slice(1) : s;
        const m = /^(\d{1,3}(,\d{3})+|\d+)(\.\d{1,2})?$/.exec(body);
        if (!m)
            return null;
        const cents = Number(m[1].replace(/,/g, '')) * 100 + Number(((m[3] ?? '.').slice(1) + '00').slice(0, 2));
        return Number.isSafeInteger(cents) ? (neg ? -cents : cents) : null;
    }
    const neg = s.startsWith('-');
    if (neg)
        s = s.slice(1);
    if (!/^[\d.,]+$/.test(s))
        return null;
    const lastComma = s.lastIndexOf(',');
    const lastDot = s.lastIndexOf('.');
    let intPart;
    let frac = '';
    if (lastComma > -1 && lastComma > lastDot) {
        // Komma ist Dezimaltrenner, Punkte sind Tausender
        intPart = s.slice(0, lastComma);
        if (intPart.includes('.') && !/^\d{1,3}(\.\d{3})+$/.test(intPart))
            return null;
        intPart = intPart.replace(/\./g, '');
        frac = s.slice(lastComma + 1);
    }
    else if (lastDot > -1 && lastComma === -1 && /^\d{1,3}(\.\d{3})+$/.test(s)) {
        // „1.234.567“ ohne Komma: Tausenderpunkte
        intPart = s.replace(/\./g, '');
    }
    else if (lastDot > -1) {
        intPart = s.slice(0, lastDot).replace(/,/g, '');
        frac = s.slice(lastDot + 1);
    }
    else {
        intPart = s;
    }
    if (!/^\d+$/.test(intPart || '0') || !/^\d{0,2}$/.test(frac))
        return null;
    const cents = Number(intPart || '0') * 100 + Number((frac + '00').slice(0, 2));
    if (!Number.isSafeInteger(cents))
        return null;
    return neg ? -cents : cents;
}
const fmt2 = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
/** Cent → „120.000,50“ (ohne Währungszeichen, für Eingabefelder). */
export function centsToInput(cents) {
    return fmt2.format(cents / 100);
}
/** Umsatzsteuersatz, mit dem ein Teilbetrag aus Workday (brutto) auf netto zurückgerechnet wird. */
export const VAT_RATE = 0.19;
/**
 * Offener Betrag einer Rechnung NETTO. Workday meldet „Amount Due“ brutto; im Tool rechnen wir überall netto.
 * - bezahlt → 0
 * - kein Amount Due oder Amount Due ≥ Nettobetrag (voll offen, brutto oder netto) → Nettobetrag der Rechnung
 * - sonst (teilweise bezahlt) → Amount Due / 1,19, höchstens der Nettobetrag
 * Gutschriften (negativ) bleiben beim Nettobetrag.
 */
export function openNetCents(netCents, status, amountDueCents) {
    if (status === 'paid')
        return 0;
    if (amountDueCents === null || netCents <= 0 || amountDueCents >= netCents)
        return netCents;
    return Math.max(0, Math.min(netCents, Math.round(amountDueCents / (1 + VAT_RATE))));
}
//# sourceMappingURL=money.js.map